<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="mainBread"
          >
            <el-breadcrumb-item>{{ $t("menu.Home_View") }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t("menu.Alarm_View") }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-form
            ref="formselect"
            :model="formselect"
            class="queryform_div"
            label-width="134px"
          >
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="8">
                <el-form-item :label="$t('desc.project')">
                  <el-select
                    v-model="formselect.customerId"
                    filterable
                    collapse-tags
                    style="width: 100%"
                    :placeholder="$t('desc.select')"
                    size="small"
                    @change="changeCust"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="item in customerInfo"
                      :key="item.id"
                      :label="item.customerName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>              
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.machineType')">
                  <el-select
                    v-model="formselect.modelId"
                    style="width: 100%"
                    size="small"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    @change="changeModel"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item, index) in deviceModelArrShow"
                      :value="item.id"
                      :label="item.modelDesc"
                      :key="'inx2' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('desc.airCompressorSN')">
                  <el-select
                    v-model="formselect.snCode"
                    style="width: 100%"
                    size="small"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item, index) in AllSnShow"
                      :value="item.dsn"
                      :label="item.dsn"
                      :key="'inx1' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.dateType')">
                  <el-select
                    v-model="formselect.dateType"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                    @change="changeDateType"
                  >
                    <el-option value="3M" :label="$t('desc.recent3M')"></el-option>
                    <el-option value="6M" :label="$t('desc.t3To6M')"></el-option>
                    <el-option value="1Y" :label="$t('desc.t6To12M')"></el-option>
                    <el-option value="1YAgo" :label="$t('desc.t1YAgo')"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="16" :sm="12" :xs="24">
                <el-form-item :label="$t('title.Datefrom')">
                  <el-date-picker
                    size="small"
                    v-model="times"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    :picker-options="pickerBeginDateBefore"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.alarmStatus')">
                  <el-select
                    style="width: 100%"
                    size="small"
                    v-model="formselect.alarmStatus"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option value="1" :label="$t('title.error')"></el-option>
                    <el-option
                      value="2"
                      :label="$t('title.relieve')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.alarmType')">
                  <el-select
                    style="width: 100%"
                    size="small"
                    v-model="formselect.alarmType"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      value="onWarning"
                      :label="$t('title.warning')"
                    ></el-option>
                    <el-option
                      value="onTrip"
                      :label="$t('title.trip')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.readStatus')">
                  <el-select
                    v-model="formselect.readStatus"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option value="1" :label="$t('title.read')"></el-option>
                    <el-option
                      value="0"
                      :label="$t('title.unread')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

            <el-row :gutter="24">
              <el-col :xs="24" >
                <el-form-item label=" ">
                  <el-button
                    type="primary"
                    @click="getData('search')"
                    size="small"
                    >{{ $t("button.query") }}</el-button
                  >
                  <el-button @click="reset" size="small">{{
                    $t("button.reset")
                  }}</el-button>
                  <el-button
                    icon="el-icon-download"
                    size="small"
                    style="float: right"
                    :loading="loading"
                    @click="exportAlarm"
                    >{{ $t("button.exportAll") }}</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <div class="tableDiv">
              <el-table
                stripe
                v-loading="tableLoading"
                :data="tableData1"
                style="width: 100%"
                class="alarmTable"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="55"
                >
                </el-table-column>
                <el-table-column
                  prop="State"
                  :label="$t('desc.state')"
                  width="60"
                  align=""
                >
                  <template slot-scope="scope">
                    <el-tag
                      effect="dark"
                      :type="StateType(scope.row.status)"
                      disable-transitions
                      ><i :class="StateIcon(scope.row.status)"></i>
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="alarmType"
                  :label="$t('title.alarmType')"
                  min-width="10%"
                >
                  <template slot-scope="scope">
                    <label v-if="scope.row.alarmType == 'onWarning'">{{
                      $t("title.warning")
                    }}</label>
                    <label v-else-if="scope.row.alarmType == 'onTrip'">{{
                      $t("title.trip")
                    }}</label>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="customerName"
                  :label="$t('desc.project')"
                  min-width="20%"
                >
                </el-table-column>
                <el-table-column
                  prop="alarmContent"
                  :label="$t('title.alarmContent')"
                  min-width="20%"
                >
                  <template slot-scope="scope">
                    <label>{{
                      activeLang == 'zh'? scope.row.alarmContent : scope.row.alarmContentEn
                    }}</label>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="kPower"
                  :label="$t('title.machineType')"
                  min-width="15%"
                >
                </el-table-column>
                <!-- <el-table-column prop="customerRegionName" :label="$t('title.area')" min-width="10%">
                            </el-table-column>
                            <el-table-column prop="customerCenterRegionName" :label="$t('title.customerCenter')" min-width="10%">
                            </el-table-column> -->
                <el-table-column
                  prop="dsn"
                  :label="$t('desc.airCompressorSN')"
                  min-width="15%"
                >
                  <template slot-scope="scope">
                    <label
                      class="span-line"
                      style="color: #00c9ff; cursor: pointer"
                      @click="getDeviceByDsn(scope.row.dsn,scope.row.gsn,scope.row.compressorNumber)"
                      >{{ scope.row.dsn }}</label
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="compressorNumber"
                  :label="$t('desc.compressorNumber')"
                  min-width="15%"
                >
                </el-table-column>
                <el-table-column
                  prop="alarmTime"
                  :label="$t('title.alarmTime')"
                  min-width="18%"
                >
                </el-table-column>
                <el-table-column
                  prop="relieveTime"
                  :label="$t('title.relieveTime')"
                  min-width="18%"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="isRead"
                :label="$t('title.readStatus')"
                min-width="10%"
              >
                <template slot-scope="scope">
                  <label v-if="scope.row.isRead == '1'">{{
                    $t("title.read")
                  }}</label>
                  <label v-if="scope.row.isRead == '0'">{{
                    $t("title.unread")
                  }}</label>
                </template>
              </el-table-column> -->
                <el-table-column
                  :label="$t('title.operate')"
                  width="80"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-document"
                      circle
                      size="mini"
                      @click="detail(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="getData()"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <el-dialog
      :title="$t('title.AlarmDetailInformation')"
      :visible.sync="dialog"
      :before-close="closeDetail"
      width="90%"
      top="5vh"
    >
      <div class="DeviceDiv">
        <el-row :gutter="24">
          <el-col :md="6" :sm="6" :xs="24" class="left">
            <div class="alarm-info">
              <div>
                <span>{{ $t("desc.projectName") }}</span
                >{{ AlarmInfo.customerName }}
              </div>
              <div>
                <span>{{ $t("title.region") }}</span
                >{{ AlarmInfo.customerRegionName }}
              </div>
              <div>
                <span>{{ $t("title.customerCenter") }}</span
                >{{ AlarmInfo.customerCenterRegionName }}
              </div>
            </div>
            <div class="info">
              <div>
                <span>{{ $t("desc.airCompressorSN") }}</span
                >{{ AlarmInfo.dsn }}
              </div>
              <div>
                <span>{{ $t("title.productCategories") }}</span
                >{{ AlarmInfo.productBig }}
              </div>
              <div>
                <span>{{ $t("title.smallClassProduct") }}</span
                >{{ AlarmInfo.productSmall }}
              </div>
              <div>
                <span>{{ $t("title.machineType") }}</span
                >{{ AlarmInfo.productType }}
              </div>
              <div>
                <span>{{ $t("title.airCompressorService") }}</span>
                {{ AlarmInfo.serviceType }}
              </div>
              <div>
                <span>{{ $t("title.controllCcn") }}</span>
                {{ AlarmInfo.ccn }}
              </div>
              <div>
                <span>{{ $t("title.ccnVersion") }}</span>
                {{ AlarmInfo.ccnVersion }}
              </div>
              <div>
                <span>{{ $t("desc.compressorNumber") }}</span>
                {{ AlarmInfo.compressorNumber }}
              </div>
            </div>
          </el-col>
          <el-col :md="18" :sm="18" :xs="24" class="right">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="12" :lg="6">
                <div class="block">
                  <h4>{{ $t("title.alarmCode") }}</h4>
                  <span style="color: #cf554a">{{ AlarmInfo.alarmCode }}</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6">
                <div class="block">
                  <h4>{{ $t("title.alarmType") }}</h4>
                  <span>{{
                    AlarmInfo.alarmType?(AlarmInfo.alarmType.toUpperCase().indexOf('TRIP') >-1 ? $t("title.trip") : $t("title.warning")):""
                  }}</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12">
                <div class="block">
                  <h4>{{ $t("title.alarmContent") }}</h4>
                  <span>{{ AlarmInfo.alarmContent }}</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12">
                <div class="block">
                  <h4>{{ $t("title.alarmTime") }}</h4>
                  <span>{{ AlarmInfo.alarmTime }}</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12">
                <div class="block">
                  <h4>{{ $t("title.relieveTime") }}</h4>
                  <span>{{ AlarmInfo.relieveTime }}</span>
                </div>
              </el-col>
            </el-row>

            <div style="margin-top: 10px">
              <div
                class="echarts_Monitoring"
                style="border: 0; position: relative"
              >
                <el-tabs v-model="ActiveTab" type="border-card">
                  <el-tab-pane :label="$t('title.expertAdvice')" name="suggest">
                    <template>
                      <div class="TabsTableDiv">
                        <el-table
                          :data="AlarmInfo.expertList"
                          stripe
                          style="width: 100%"
                          max-height="450"
                          :empty-text="$t('desc.noData')"
                        >
                          <el-table-column
                            type="index"
                            :label="$t('title.serialNumber')"
                            width="60px"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="reason"
                            :label="$t('desc.possibleCauseOfFailure')"
                            min-width="120px"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="solution"
                            :label="$t('desc.solution')"
                            min-width="120px"
                          >
                          </el-table-column>
                        </el-table>
                      </div>
                    </template>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('desc.faultSnapshot')" name="snapshot">
                    <template>
                      <div class="timeBtn">
                        <el-select
                          multiple
                          filterable
                          collapse-tags
                          :placeholder="$t('title.selectFive')"
                          v-model="KTarget"
                          :multiple-limit="5"
                          @change="changeAlarmCode"
                          style="
                            width: 50%;
                            min-width: 200px;
                            margin-left: 6px;
                            float: right;
                          "
                        >
                          <el-option
                            v-for="item in alarmGatherOption"
                            :key="item.id"
                            :label="
                              activeLang == 'zh' ? item.gatherNameZH : item.gatherName
                            "
                            :value="item.gatherName"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div
                        class="echarts"
                        id="KchartTime3"
                        style="height: 350px; margin-top: 15px"
                        v-show="ActiveTab == 'snapshot'"
                      ></div>
                      <div style="position: relative; display: flex; right: 40px; justify-content: flex-end; font-size: 13px;">
                      <span @click="exportTripWarningMonitor()" style="cursor: pointer; text-decoration: underline;">{{ $t("desc.downloadDataDetails")}}</span>
                    </div>
                    </template>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <monitor-deviceInfo-Dialog
      ref="deviceInfoRef"
      :dialogClient="dialogDevice"
      :title="deviceTitle"
      :cNumbertitle="cNumbertitle"
      :DeviceInfo="DeviceInfoShow"
      :CustomerInfo="CustomerInfo"
      :gatherOption="ccnGatherOption"
      :ccnCodeList222="ccnCodeList222"
      :activeLang="activeLang"
      :isDingOrBian="isDingOrBian"
      :echartID="echartID"
      :echartIDHistory="echartIDHistory"
      :maintainList="maintainList"
      :IsShowSensitive="IsShowSensitive"
      :UseRateData="UseRateData"
      @getMonitorHistoryByGsn="getMonitorHistoryByGsn"
      @dialogVisibleEvent="openDevice"
      @openCcnTable="openCcnTable"
      @getRealData="getRealData"
      @changeCode="changeCode"
      @openMaintain="openMaintainDialog"
    >
    </monitor-deviceInfo-Dialog>
    <monitor-ccn-table
      :dialogClient="dialogDeviceCCN"
      :title="tableTitle"
      :tableCCN="tableCCN"
      :tableType="tableType"
      @dialogVisibleEvent="openCcnTable"
    >
    </monitor-ccn-table>

    <monitor-maintain-dialog
      :dialogClient="dialogMaintain"
      :title="maintainTitle"
      :serviceform="serviceform"
      :tableService="tableService"
      @dialogVisibleEvent="openMaintainDialog"
    >
    </monitor-maintain-dialog>
  </div>
</template>
<script>
import {
  setItemToLocalstorage,
  delItemFormLocalstorage,
  getItemFormLocalstorage,
  exportTripWarningMonitorHalf,
} from "../../../utils/package-localstorage";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorMaintainDialog from "../../components/content/monitor/MonitorMaintainDialog";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { contratMixin } from "../../mixins/monitorWebMixin";
import {
  GetUserDevices,
  getUserCustomerList,
  GetCustomerRegions,
  exportExcelNew,
  GetUserDeviceModels,
  WebGetAlarmService,
  getAlarmDetailById,
  getAlarmMonitor,
  getDeviceGatherList
} from "../../api/api";

export default {
  name: "index",
  components: {
    "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
    "monitor-ccn-table": monitorCcnTable,
    "monitor-maintain-dialog": monitorMaintainDialog,
  },
  mixins: [contratMixin],
  
  
  inject: ["reload"],
  data() {
    let date = new Date(); 
    let date1 = new Date(); 
    date.setDate(date.getDate() - 7);
    return {
      pacCcnFilterArr:
      ["System Pressure",
      "Stage 1 Temperature",
      "Stage 1 Vibration",
      "Stage 1 Pressure",
      "Stage 2 Temperature",
      "Stage 2 Vibration",
      "Stage 2 Pressure",
      "Stage 3 Temperature",
      "Stage 3 Vibration",
      "Stage 3 Pressure"],
      loading: false,
      tableLoading: false,
      dialog: false,
      times: [date, date1],
      formselect: {
        alarmType: "",
        alarmStatus: "",
        readStatus: "",
        startTime: "",
        endTime: "",
        snCode: "",
        customerId: "",
        isContainWJ: false,
        gsnCode: "",
        modelId:"",
        dateType: "3M"
      },
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData1: [],
      AlarmInfo: {
        customerCenterRegionName: "",
        customerRegionName: "",
        dsn: "",
        gsn: "",
        alarmTime: "",
        alarmType: "",
      },
      region: [],
      center: [],
      managerList: [],
      AllSn: [],
      AllSnShow: [],
      deviceModelArr:[],
      deviceModelArrShow:[],
      customerInfo: [],
      loading: false,
      tableLoading: false,
      hasAlarmExport: false,
      //空压机详细
      gsnStateList: {
        0: "未连接",
        1: "正常",
        2: "警告",
        "-1": "脱机",
      },
      dialogTitle: "",
      dialogMonitor: false,
      ccnCodeList: [],
      translateList: {
        定期保养: "desc.pmPureLabor",
        一次性保养: "desc.oneTimePM",
        延长保修: "desc.extendWarranty",
        工厂保内: "desc.factoryWarranty",
        其他: "desc.other",
      },
      bondStatusTraslate: {
        已绑定: "title.Bound",
        未绑定: "title.Unbound",
      },
      //告警
      alarmList: [],
      dialogUpdate: false,
      currentRowId: "",

      // formUpdate: {
      //   GSN: "GL5012047000256",
      //   OldVersion: "2.0.0r13575",
      // },
      formUpdate: {
        GSN: "",
        OldVersion: "",
        getWayName: "",
        versionName: "",
        deviceType: "",
        versionNo: "",
        describeContent: "",
      },
      VersionTable: [],
      otaformselect: {
        name: "",
        type: "",
      },
      VersionTHeight: "",
      gsnList: [],
      ActiveTab: "suggest",
      alarmId:"",
      dateRangeStart: new Date(),
      dateRangeEnd: new Date(),
      // 监控告警
      KTarget: "",
      echartIDAlarm: {},
      historyMonitor: {},
      alarmGatherOption: [],
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
    pickerBeginDateBefore() {
      let that = this;
      return {
        disabledDate(time) {
          if (that.dateRangeStart.format("yyyy-MM-dd") === new Date().format("yyyy-MM-dd")) {
            that.dateRangeStart.setMonth(that.dateRangeStart.getMonth() - 3)
          }
          console.log(that.dateRangeEnd)
          return (
            time.getTime() > that.dateRangeEnd.getTime() ||
            time.getTime() < that.dateRangeStart.getTime()
          );
        }
      }
    },
  },
  mounted() {
    if (this.$route.params.alarmStatus) {
      this.formselect.alarmStatus = this.$route.params.alarmStatus;
    }
    if (this.$route.params.readStatus) {
      this.formselect.readStatus = this.$route.params.readStatus;
    }
    if (this.$route.params.alarmType) {
      this.formselect.alarmType = this.$route.params.alarmType;
    }
    this.getData();
    this.getCustomerInfo();
    this.getAllSN();
    this.getDeviceModelOption();
  },
  methods: {
    getAllSN() {
      var that = this;
      GetUserDevices().then((res) => {
        if (res.success) {
          that.AllSn = res.result;
          that.AllSnShow = JSON.parse(JSON.stringify(res.result));
        }
      });
    },
    changeModel(){
      let that = this;
      that.formselect.snCode = "";
      if (that.formselect.modelId && that.formselect.modelId != '全部'){
        that.AllSnShow = that.AllSn.filter(a=>that.formselect.modelId.includes(a.modelId) && that.formselect.customerId.includes(a.customerId))
      }else{
        that.AllSnShow = JSON.parse(JSON.stringify(that.AllSn));
      }
      
    },
    changeCust(){
      let that = this;
      that.formselect.modelId = "";
      that.formselect.snCode = "";
      if (that.formselect.customerId && that.formselect.customerId != '全部'){
        that.AllSnShow = that.AllSn.filter(a=>that.formselect.customerId.includes(a.customerId))
        let modelList = that.AllSnShow.map(a=>a.modelId);
        that.deviceModelArrShow = that.deviceModelArr.filter(a=>modelList.includes(a.id))
      }else{
        that.AllSnShow = JSON.parse(JSON.stringify(that.AllSn))
        that.deviceModelArrShow = JSON.parse(JSON.stringify(that.deviceModelArr))
      }
      
    },
    async getDeviceModelOption(){
      let that = this;
      let res = await GetUserDeviceModels();
      that.deviceModelArr = res.result.filter(a=>a.level == '4');;
      that.deviceModelArrShow = JSON.parse(JSON.stringify(that.deviceModelArr));
    },
    getCustomerInfo() {
      var that = this;
      getUserCustomerList().then((res) => {
        if (res.success) {
          that.customerInfo = res.result;
        }
      });
    },
    reset() {
      let date = new Date(); 
      let date1 = new Date(); 
      date.setDate(date.getDate() - 7);
      this.times = [date, date1];
      this.formselect = {
        alarmType: "",
        alarmStatus: "",
        startTime: "",
        endTime: "",
        snCode: "",
        customerId: "",
        gsnCode: "",
        modelId:"",
      };
      this.AllSnShow = JSON.parse(JSON.stringify(this.AllSn))
      this.getData("search");
    },
    async detail(e) {
      this.ActiveTab = 'suggest'
      this.KTarget = [];
      this.dialog = true;
      if (this.echartIDAlarm.id) {
        this.echartIDAlarm.hideLoading();
        this.echartIDAlarm.clear();
      }
      //查看相同的告警不重复查询
      if (this.alarmId != e.id) {
        this.alarmId = e.id
        this.AlarmInfo = {}
        let res = await getAlarmDetailById(e.id)
        this.AlarmInfo = res.result;
        let expertList = new Array();
        let arr = this.AlarmInfo.expertAdvice? this.AlarmInfo.expertAdvice.split("|"):new Array();
        for (let index = 0; index < arr.length; index++) {
          let element = arr[index];
          let detail = element.split(":");
          let problem = {
            reason: detail[0],
            solution: detail[1],
          };
          expertList.push(problem);
        }
        this.AlarmInfo.expertList = expertList;
        this.AlarmInfo.alarmContent = (this.activeLang == 'zh'?this.AlarmInfo.alarmContent:this.AlarmInfo.alarmContentEn)
        await this.getDeviceGatherList();
        await this.getAlarmMonitor();
      }
    },
    closeDetail(){
      this.dialog = false;
    },
    resetCenter() {
      this.$set(this.formselect, "customerCenterRegionId", "");
    },
    //数组对象去重
    reduce(config) {
      var hash = {};
      const newArr = config.reduceRight((item, next) => {
        hash[next.regionName]
          ? ""
          : (hash[next.regionName] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    //获取地区
    getRegion() {
      var that = this;
      //getCustomerRegionTable()
      GetCustomerRegions()
        .then((res) => {
          if (res.success) {
            // var regionList = JSON.parse(JSON.stringify(res.result.centerList))
            // var centerList = JSON.parse(JSON.stringify(res.result.centerList))
            var regionList = JSON.parse(
              JSON.stringify(res.result.filter((item) => item.level === "2"))
            );
            var centerList = JSON.parse(
              JSON.stringify(res.result.filter((a) => a.level === "3"))
            );
            that.center = centerList;
            that.region = this.reduce(regionList);
          } else {
            this.$message.error(res.error.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    getData(type = "normal") {
      this.tableLoading = true;
      if (type == "search") {
        this.pagination.current = 1;
      }
      if (this.times) {
        if (typeof(this.times[0]) == 'object') {
          this.formselect.startTime = this.times[0].format("yyyy-MM-dd");
           this.formselect.endTime = this.times[1].format("yyyy-MM-dd");
        } else {
          this.formselect.startTime = this.times[0];
          this.formselect.endTime = this.times[1];
        }
      } else {
        this.formselect.startTime = "";
        this.formselect.endTime = "";
      }
      var data = this.formselect,
        that = this;
      if (this.formselect.modelId == "all") {
        this.formselect.modelId = "";
      }
      if (this.formselect.readStatus == "all") {
        this.formselect.readStatus = "";
      }
      if (this.formselect.alarmType == "all") {
        this.formselect.alarmType = "";
      }
      if (this.formselect.alarmStatus == "all") {
        this.formselect.alarmStatus = "";
      }
      if (this.formselect.snCode == "all") {
        this.formselect.snCode = "";
      }
      if (this.formselect.customerId == "all") {
        this.formselect.customerId = "";
      }
      data.skipCount = (this.pagination.current - 1) * this.pagination.pageSize;
      data.maxResultCount = this.pagination.pageSize;
      data.pageFlag = 1;
      data.isContainWJ = false;
      WebGetAlarmService(data).then((res) => {
        if (res.success) {
          that.pagination.totalPage = res.result.totalCount;

          that.tableData1 = res.result.items;
          this.tableLoading = false;
          console.log(that.tableData1);
        }
      });
    },
    exportAlarm() {
      this.loading = true;
      if (this.times) {
        if (typeof(this.times[0]) == 'object') {
          this.formselect.startTime = this.times[0].format("yyyy-MM-dd");
           this.formselect.endTime = this.times[1].format("yyyy-MM-dd");
        } else {
          this.formselect.startTime = this.times[0];
          this.formselect.endTime = this.times[1];
        }
      } else {
        this.formselect.startTime = "";
        this.formselect.endTime = "";
      }
      var data = this.formselect,
        that = this;
      if (this.formselect.customerRegionId == "all") {
        this.formselect.customerRegionId = "";
      }
      if (this.formselect.customerCenterRegionId == "all") {
        this.formselect.customerCenterRegionId = "";
      }
      if (this.formselect.readStatus == "all") {
        this.formselect.readStatus = "";
      }
      if (this.formselect.alarmType == "all") {
        this.formselect.alarmType = "";
      }
      if (this.formselect.alarmStatus == "all") {
        this.formselect.alarmStatus = "";
      }
      if (this.formselect.snCode == "all") {
        this.formselect.snCode = "";
      }
      if (this.formselect.customerId == "all") {
        this.formselect.customerId = "";
      }
      data.skipCount = 0;
      data.maxResultCount = 9999999;
      data.pageFlag = 0;

      // var headers = [
      //   { key: "status", title: "状态" },
      //   { key: "alarmType", title: "告警类型" },
      //   { key: "customerRegionName", title: "大区" },
      //   { key: "customerCenterRegionName", title: "客户中心" },
      //   { key: "customerName", title: "客户" },
      //   { key: "dsn", title: "空压机SN号" },
      //   { key: "alarmTime", title: "告警时间" },
      //   { key: "relieveTime", title: "解除时间" },
      //   { key: "isRead", title: "读取状态" },
      // ];
      var exportData = [
        [
          this.$t('desc.state'),
          this.$t('title.alarmType'),
          this.$t('title.area'),
          this.$t('title.customerCenter'),
          this.$t('desc.customer'),
          this.$t('desc.airCompressorSN'),
          this.$t("desc.compressorNumber"),
          this.$t('title.machineType'),
          this.$t('desc.gatewaySN'),
          this.$t("title.alarmCode"),
          this.$t("title.alarmContent"),
          this.$t("title.alarmTime"),
          this.$t("title.relieveTime"),
          //"读取状态",
        ],
      ];

      var fileName = this.$t("exportContent.告警信息列表")+".xlsx";
      GetAlarmServiceForWeb(data).then((res) => {
        if (res.success) {
          var data = res.result.items;

          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }
              if (item[key] === "onTrip") {
                item[key] = this.$t("title.trip");
              }
              if (item[key] === "onWarning") {
                item[key] = this.$t("title.warning");
              }
              if (key == "isRead") {
                if (item[key] == true) {
                  item[key] = "已读";
                }
                if (item[key] == false) {
                  item[key] = "未读";
                }
              }
              if (key == "status") {
                if (item[key] == 1) {
                  item[key] = this.$t("title.error");
                }
                if (item[key] == 2) {
                  item[key] = this.$t("title.relieve");
                }
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [];
            rowData = [
              item.status,
              item.alarmType,
              item.customerRegionName,
              item.customerCenterRegionName,
              item.customerName,
              item.dsn,
              item.compressorNumber,
              item.kType +
                (item.kProduct ? "/" + item.kProduct : "") +
                (item.kSmall ? "/" + item.kSmall : "") +
                (item.kPower ? "/" + item.kPower : ""),
              item.gsn,
              item.alarmCode,
              item.alarmContent,
              item.alarmTime,
              item.relieveTime,
              //item.isRead,
            ];
            exportData.push(rowData);
          });
          // exportExcel(headers, dataSource, fileName);
          exportExcelNew(exportData, fileName);
          this.loading = false;
        }
      });
    },
    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},
    StateType(State) {
      // if (State == "onWarning") return "warning";
      // else if (State == "onTrip") return "danger";
      // else if (State == "onFinish") return "info";
      if (State == "1") return "danger";
      else if (State == "2") return "info";
    },
    StateIcon(State) {
      // if (State == "onWarning") return "el-icon-warning-outline";
      // else if (State == "onTrip") return "el-icon-circle-close";
      // else if (State == "onFinish") return "el-icon-circle-check";
      if (State == "1") return "el-icon-warning-outline";
      else if (State == "2") return "el-icon-circle-check";
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData();
    },
    
    SetMapHeight() {
      this.TableH = window.innerHeight * 0.8 - 190 + "px";
    },
    changeDateType(){
      this.dateRangeStart = new Date();
      this.dateRangeEnd = new Date();
      if (this.formselect.dateType == '3M') {
        this.dateRangeStart.setMonth(this.dateRangeStart.getMonth() - 3);
      } else if (this.formselect.dateType == '6M') {
        this.dateRangeEnd.setMonth(this.dateRangeEnd.getMonth() - 3);
        this.dateRangeStart.setMonth(this.dateRangeStart.getMonth() - 6);
      } else if (this.formselect.dateType == '1Y') {
        this.dateRangeEnd.setMonth(this.dateRangeEnd.getMonth() - 6);
        this.dateRangeStart.setMonth(this.dateRangeStart.getMonth() - 12);
      } else {
        this.dateRangeEnd.setMonth(this.dateRangeEnd.getMonth() - 12);
        this.dateRangeStart.setMonth(this.dateRangeEnd.getMonth() - 48);
      } 
      let date = new Date(this.dateRangeEnd.format("yyyy-MM-dd"));
      date.setDate(date.getDate() - 7);
      this.times = [date, this.dateRangeEnd];
    },
    async getAlarmMonitor() {
      let that = this;
      that.historyMonitor = {};
      that.historyMonitor.chartDataList = new Array();
      that.historyMonitor.codeList = new Array();
      try {
        let res = await getAlarmMonitor(this.AlarmInfo.id);
        let kchart = this.$echarts.init(document.getElementById("KchartTime3"));
        this.echartIDAlarm = kchart;
        //展示echart loading
        kchart.showLoading({
          text: "loading",
          color: "#3A6BB5",
          textColor: "#000",
          maskColor: "#242731",
        });
        let data = res.result;
        that.historyMonitor = data;
        if (!data || data.chartDataList.length === 0) {
          kchart.hideLoading();
          this.echartIDAlarm.clear();
          return false;
        }
        that.drawChart();
      } catch (error) {
        
      }
    },
    changeAlarmCode(codeList) {
      let that = this;
      if (!that.historyMonitor || that.historyMonitor.chartDataList.length === 0) {
        return false;
      }
      that.drawChart();
    },
    drawChart() {
      let that = this;
      let totalData = {};
      totalData.chartDataList = new Array();
      totalData.codeList = new Array();
      totalData = that.historyMonitor;
      let selDataList = that.historyMonitor.chartDataList.filter((item) =>
        that.KTarget.some((aaa) => aaa === item.code)
      );
      totalData.chartDataList = selDataList;
      totalData.codeList = that.historyMonitor.codeList.filter((item) =>
        that.KTarget.some((aaa) => aaa === item)
      );
      //隐藏echart loading
      if (that.echartIDAlarm) {
        that.echartIDAlarm.hideLoading();
        this.$nextTick(() => {
          setTimeout(() => {
              that.initEchartsGsn(this.echartIDAlarm, totalData);
          }, 300);
        });
      }

    },
    async getDeviceGatherList() {
      console.log(this.AlarmInfo)
      let res = await getDeviceGatherList(this.AlarmInfo.dsn);
      this.alarmGatherOption = res.result;
      this.$nextTick(() => {
        if (
          this.alarmGatherOption.some(
            (aaa) => aaa.gatherName == "Compressor Discharge Temperature"
          )
        ) {
          this.KTarget.push("Compressor Discharge Temperature");
        }
        if (
          this.alarmGatherOption.some(
            (aaa) => aaa.gatherName == "Final Stage Discharge Temperature"
          )
        ) {
          this.KTarget.push("Final Stage Discharge Temperature");
        }
        if (
          this.alarmGatherOption.some(
            (aaa) => aaa.gatherName == "Compressor Discharge Pressure"
          )
        ) {
          this.KTarget.push("Compressor Discharge Pressure");
        }
        if(this.AlarmInfo.productLineType == "PAC"){
          if (
            this.alarmGatherOption.some(
              (aaa) => aaa.gatherName == "System Pressure"
            )
          ) {
            this.KTarget.push("System Pressure");
          }
        }
        if(this.AlarmInfo.productLineType == 'BV'){
          if (this.alarmGatherOption.some(a => a.gatherName == "Airend Discharge Pressure")) {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Airend Discharge Pressure");
            this.KTarget.push(code.gatherName);
          }
          if (this.alarmGatherOption.some(a => a.gatherName == "Airend Discharge Temperature")) {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Airend Discharge Temperature");
            this.KTarget.push(code.gatherName);
          }
          if (this.alarmGatherOption.some(a => a.gatherName == "Blower Inlet Pressure") && this.AlarmInfo.kPower == "BM200") {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Blower Inlet Pressure");
            this.KTarget.push(code.gatherName);
          }
          if (this.alarmGatherOption.some(a => a.gatherName == "Blower Inlet Temperature") && this.AlarmInfo.kPower == "BM200") {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Blower Inlet Temperature");
            this.KTarget.push(code.gatherName);
          }
        }
      });
    },
    async exportTripWarningMonitor() {
      try {
        let that = this;
        let res = await exportTripWarningMonitorHalf(that.AlarmInfo.id);
        let data = res.result;

        let exportData = new Array();
        let titleList = [this.$t("title.Index")];
        titleList.push(...data.dateTimeList);
        exportData.push(titleList);
        let fileName =
          this.AlarmInfo.dsn +
          "_" +
          that.AlarmInfo.alarmTime
            .replace("-", "")
            .replace("-", "")
            .replace(":", "")
            .replace(":", "")
            .replace(" ", "") +
          "_" +
          that.AlarmInfo.alarmType.replace("on", "") +
          "_" +
          that.AlarmInfo.alarmCode +
          ".xlsx";
        data.detailList.forEach((element) => {
          let rowData = [element.name];
          element.dataList.forEach((item) => {
            rowData.push(item);
          });
          exportData.push(rowData);
        });
        exportExcelNew(exportData, fileName);
      } catch (error) {
        this.$message({
          showClose: true,
          message: error.error.message,

          type: "error",
        });
      }
    },
  },
};
</script>


